import { Link } from "react-router-dom";

/* SAMPLE DATA */
import navMenu from "../../data/navigation";

/* ASSETS */
import Logo from "../../assets/images/white-logo.png";

const Sidebar = () => {
  var pathname = window.location.pathname;

  return (
    <section className="h-sidebar w-sidebar bg-[#000000] transition-all duration-300 ease-linear rounded-xl shadow-xl p-5">
      {/* HEADER */}
      <div className=" border-b border-white border-opacity-20 px-5 flex items-center text-center bg-white rounded-lg">
        <img
          src={`https://storage.googleapis.com/cdn-roundtechsquare/dr-shah/molar-logo.png`}
          className=" w-auto h-24 object-contain  "
          alt="Dr. Ankit SHah"
        />
      </div>

      {/* NAVIGATION OPTIONS */}
      <div className="h-[80vh] flex flex-col justify-between mt-5">
        <div className="">
          <div className="mt-0">
            {navMenu.map((nav) => (
              <Link
                to={nav.link}
                key={nav.id}
                className="w-full group flex items-center gap-3 first:mt-0 mt-5"
              >
                <nav.icon
                  className={`w-5 h-5 text-sidebarText ${pathname ===
                    nav.link &&
                    "text-white"} group-hover:text-white transition-all duration-300 ease-in-out`}
                />
                <div>
                  <p
                    className={`text-base font-proxima-semibold text-sidebarText ${pathname ===
                      nav.link &&
                      "text-white"} group-hover:text-white leading-none transition-all duration-300 ease-in-out`}
                  >
                    {nav.name}
                  </p>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Sidebar;
